import { LegalPage } from "./_legal_page";

const sections = [
  {
    title: "第1条 適用",
    body: [
      "本利用規約は、株式会社Cajonが提供する Hairbook Salon Pages の利用条件を定めるものです。",
      "利用者は、本サービスを閲覧または利用することにより、本規約に同意したものとみなされます。",
    ],
  },
  {
    title: "第2条 本サービスの内容",
    body: [
      "本サービスは、美容室、スタッフ、ヘアスタイル、メニュー等の情報を掲載し、外部予約サービス等への導線を提供するものです。",
      "掲載情報は、サロン、外部サービス、その他の情報提供元から取得または提供された内容をもとに構成されます。",
    ],
  },
  {
    title: "第3条 掲載情報と予約",
    body: [
      "掲載される料金、営業時間、空席状況、メニュー内容等は変更される場合があります。実際の提供条件は、予約先またはサロンが提示する内容をご確認ください。",
      "本サービスから外部サイトへ遷移して行われる予約、問い合わせ、決済等については、遷移先サービスまたはサロンの定める条件が適用されます。",
    ],
  },
  {
    title: "第4条 禁止事項",
    body: [
      "利用者は、本サービスの利用にあたり、法令または公序良俗に反する行為、第三者の権利を侵害する行為、不正アクセス、過度なクローリング、サービス運営を妨げる行為を行ってはなりません。",
      "当社は、禁止事項に該当すると判断した場合、事前の通知なく利用制限その他必要な措置を講じることがあります。",
    ],
  },
  {
    title: "第5条 免責",
    body: [
      "当社は、本サービスに掲載される情報の正確性、完全性、最新性、有用性について保証しません。",
      "本サービスの利用、外部サイトへの遷移、サロンとの取引により利用者に生じた損害について、当社に故意または重過失がある場合を除き責任を負いません。",
    ],
  },
  {
    title: "第6条 規約の変更",
    body: [
      "当社は、必要に応じて本規約を変更することがあります。変更後の規約は、本ページに掲載された時点から効力を生じます。",
    ],
  },
];

export default function SalonpageTerms() {
  return (
    <LegalPage
      title="利用規約"
      description="Hairbook Salon Pages の利用条件を定めます。"
      updatedAt="2026年6月25日"
      sections={sections}
    />
  );
}
